import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import {fetchHomeMediasTopVideos} from '../../../../../creators/home.medias.topvideos';

import Carousel from '../../../../components/Carousel';
import Thumb from '../../../../components/Thumb';
import {shuffleArray} from "../../../../../libs/helper";


class VideoHome extends React.Component {


    constructor(props){
        super(props);
        this.props.fetchHomeMediasTopVideos();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if(nextProps.mediasLoading !== this.props.mediasLoading && nextProps.mediasInitialized){
            return true;
        }
        return false;
    }


    render() {
        let medias = this.props.medias || [];
        if(this.props.mediasInitialized){
            medias = shuffleArray(medias, 30);
        }
        return (
            <Carousel>
                <div className="pane">
                    <div className="row">
                        {this.props.mediasInitialized && medias.slice(0, 5).map((video) => (
                            <Thumb
                                key={video._id}
                                {...video}
                            />
                        ))}
                    </div>
                    <div className="row">
                        {this.props.mediasInitialized && medias.slice(5, 10).map((video) => (
                            <Thumb
                                key={video._id}
                                {...video}
                            />
                        ))}
                    </div>
                </div>
                <div className="pane">
                    <div className="row">
                        {this.props.mediasInitialized && medias.slice(10, 15).map((video) => (
                            <Thumb
                                key={video._id}
                                {...video}
                            />
                        ))}
                    </div>
                    <div className="row">
                        {this.props.mediasInitialized && medias.slice(15, 20).map((video) => (
                            <Thumb
                                key={video._id}
                                {...video}
                            />
                        ))}
                    </div>
                </div>
                <div className="pane">
                    <div className="row">
                        {this.props.mediasInitialized && medias.slice(20, 25).map((video) => (
                            <Thumb
                                key={video._id}
                                {...video}
                            />
                        ))}
                    </div>
                    <div className="row">
                        {this.props.mediasInitialized && medias.slice(25, 30).map((video) => (
                            <Thumb
                                key={video._id}
                                {...video}
                            />
                        ))}
                    </div>
                </div>
            </Carousel>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        medias: state.homeMediaTopVideos.data,
        mediasLoading: state.homeMediaTopVideos.loading,
        mediasInitialized: state.homeMediaTopVideos.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchHomeMediasTopVideos,
}, dispatch);


export default connect(mapStateToProps, mapDispatchToProps)(VideoHome);
